<template>
  <h3 v-bind="$attrs" class="h4 tile-header p-2 px-4">
    <span v-if="icon">
      <svg class="icon-1">
        <use :xlink:href="`#${icon}`"></use>
      </svg>
    </span>
    <span v-if="title">{{ title }}</span>
    <slot />
  </h3>
</template>
<script>
export default {
  name: "CardHeader",

  props: {
    title: {
      type: [String, null],
      default: null,
    },

    icon: {
      type: [String, null],
      default: null,
    },
  }
}
</script>
